//import SlButton from '@shoelace-style/shoelace/dist/react/button';
import SlCard from '@shoelace-style/shoelace/dist/react/card';
import SlButton from '@shoelace-style/shoelace/dist/react/button';
//import SlDialog from '@shoelace-style/shoelace/dist/react/dialog';
//import { useState } from 'react';

import React, { useEffect, useState } from 'react';
import axios from 'axios';

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
    lineHeight: '1.6',
    color: '#333',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
  },
  title: {
    fontSize: '36px',
    marginBottom: '10px',
  },
  subtitle: {
    fontSize: '20px',
    color: '#666',
  },
  benefitsSection: {
    marginBottom: '40px',
  },
  sectionTitle: {
    fontSize: '28px',
    marginBottom: '20px',
    textAlign: 'center',
  },
  benefitsGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '20px',
  },
  benefit: {
    flex: '1 1 200px',
    backgroundColor: 'rgb(249, 249, 249, 0.7)',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    textAlign: 'center',
  },
  keyValuesSection: {
    marginBottom: '40px',
  },
  valuesList: {
    listStyleType: 'none',
    padding: 0,
    fontSize: '18px',
  },
  footer: {
    textAlign: 'center',
    marginTop: '40px',
  },
};

const css = `
  .hero-block {
    /* change color to shoelace for dark mode */
    background-color: #aea49e;
    background-image: url(images/background1.png);
    background-size: contain;
  }

  .hero-sub-page {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    padding-bottom: 0;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    min-height: 50vw;
    height: 80vh;
    max-height: 62.5vw;
}
.hero-sub-page__text-content {
    z-index: 3;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.hero-sub-page__heading {
    padding-top: 0;
    padding-bottom: 0;
    position: relative;
    z-index: 2;
    padding-left: 40px;
    padding-right: 40px;
}

.feature-text {
    text-align: left;
    height: 100%;
}

.feature-text__inner-wrapper {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: visible;
    text-align: left;
    display: flex;
}
.feature-text__left {
    text-align: left;
}

.eyebrow {
    margin-bottom: 12px;
    text-align: left;
    font-family: "Clarkson", Helvetica, sans-serif;
    font-style: normal;
    font-weight: 500;
    line-height: 1.2em;
    letter-spacing: 0;
    text-rendering: geometricPrecision;
    text-transform: uppercase;
    text-decoration: none;
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
}

h1 {
    font-size: 5vw;
    max-width: 8em;
    text-align: left;
    margin-bottom: 16px;
}

.feature-text__right {
    text-align: left;
}

.feature-text__paragraphs {
    text-align: left;
}

.feature-text__links {
    text-align: left;
    position: relative;
    border-bottom: none;
    font-family: "Clarkson", Helvetica, sans-serif;
    font-style: normal;
    font-weight: 500;
    line-height: 1.2em;
    letter-spacing: 0;
    text-rendering: geometricPrecision;
    text-transform: uppercase;
    text-decoration: none;
    font-size: 2vw;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin-top: 24px;
}

.link {
    white-space: nowrap;
    text-align: left;
}

.link__text {
    text-align: left;
}

.hero-sub-page__background-images {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.hero-sub-page__background-image-container {
    display: block;
    width: 100%;
    height: 100%;
}




  .card-overview {
    min-width: 300px;
  }

  .card-overview small {
    color: var(--sl-color-neutral-500);
  }

  .card-overview [slot="footer"] {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  .card-maintitle {
    font-size: 2vw;
    text-align: center;

    ul {
      text-align: left;
    }
  }
  .card-title {
    text-align: center;
  }
  .card-image {
    padding: 20px;
    width: 250px;
    border: 2px solid var(--sl-color-gray-300);
    margin: 1vw;
  }

  .card-image:hover {
    border: 2px solid var(--sl-color-neutral-1000);
    box-shadow: 2px 2px 2px var(--sl-color-gray-400);
    /* cursor: pointer; */
  }
`;


const Home = () => {
   // const [open, setOpen] = useState(false);
    const _onClick = (one, two) => {
        //setOpen(true)
    }
    return (
        <>
      {/*  <SlDialog label="Dialog" open={open} onSlAfterHide={() => setOpen(false)}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        <SlButton slot="footer" variant="primary" onClick={() => setOpen(false)}>
          Close
        </SlButton>
      </SlDialog>  */}
        <div className="hero-block">
            <div className="hero-sub-page">
                <div className="hero-sub-page__text-content">
                    <div className="hero-sub-page__heading">
                        <div className="feature-text" >
                            <div className="feature-text__inner-wrapper ">
                                <div className="feature-text__left">
                                    <div className="eyebrow"></div>
                                    <h1>Multifamily Housing Development</h1>
                                </div>
                                <div className="feature-text__right">
                                    <div className="feature-text__paragraphs">
                                                Feasibility Analysis, Permit Application, Construction, Property Management.
                                    </div>
                                    {/* <div className="feature-text__links" data-reveal-self="" data-has-intersected="true" data-scrolled-into-view="true" data-scrolled-past-view="true">
                                        <a className="link link--is-button theme-dark-background" data-component-name="link" data-component-id="20" href="/templates" property="item" typeof="WebPage" aria-label="Get Started" data-identifier="cta" data-section="hero">
                                            <span className="link__text" property="name">
                                                Get Started  
                                            </span>
                                        </a>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SlCard className="card-overview">
         {/*  <img
            slot="image"
            src="https://images.unsplash.com/photo-1559209172-0ff8f6d49ff7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80"
            alt="A kitten sits patiently between a terracotta pot and decorative grasses."
          />
          <strong>Mittens</strong> */}
         {/*  <br />
          <div className="card-maintitle" >
            <p>
              We focus on end to end property construction and management for affordable multifamily projects in the Bay Area.
              <ul>
                <li>Feasibility analysis</li>  
                <li>Lot split & acquisition</li>  
                <li>Building design and permit application</li>
                <li>Construction</li>
                <li>Property Management</li>
              </ul>
            </p>
          </div>
          <br /> */}

<div style={styles.container}>
      {/* <header style={styles.header}>
        <p style={styles.subtitle}>We help small developers and home owners in the development: from idea conception/feasibility to final inspection and post construction (Property Management)</p>
      </header> */}
      
      <section style={styles.benefitsSection}>
        <h2 style={styles.sectionTitle}>Services</h2>
        <div style={styles.benefitsGrid}>
          <div style={styles.benefit}>
            <h3>Feasibility analysis</h3>
            {/* <p>Run analysis and calculate ROI and other metrics</p> */}
          </div>
          <div style={styles.benefit}>
            <h3>Lot split & acquisition</h3>
            {/* <p>Use current California laws (ADUs, SB9, SB684, SB1123, SB1211) to increase value and ROI.</p> */}
          </div>
          <div style={styles.benefit}>
            <h3>Building design and permit application</h3>
            {/* <p>Coordination between stakeholders and building departments is key to get projects approved afficiently</p> */}
          </div>
          <div style={styles.benefit}>
            <h3>Construction</h3>
            {/* <p>List of Materials, Contractors, Suppliers</p> */}
          </div>
        </div>
      </section>
     

     {/*  <section style={styles.keyValuesSection}>
        <h2 style={styles.sectionTitle}>Our Core Values</h2>
        <ul style={styles.valuesList}>
          <li><strong>Reliability:</strong> Dependable service you can trust anytime.</li>
          <li><strong>Customer Satisfaction:</strong> Prioritizing your needs and feedback.</li>
          <li><strong>Transparency:</strong> Clear communication and honest billing.</li>
          <li><strong>Sustainability:</strong> Eco-friendly practices to protect your property and the environment.</li>
        </ul>
      </section> */}

    


          <h2>Portfolio</h2>
          <div slot="footer">

           

          <SlCard className="card-image" id={"DUPLEX + 2 ADUS"} onClick={_onClick}>
          <img
            slot="image"
            src="./images/DUPLEX+2ADU.png"
            alt="A kitten walks towards camera on top of pallet."
          />
          <div className="card-title">DUPLEX + 2 ADUS</div>
        </SlCard>
        <SlCard className="card-image" id={"TOWNHOMES"} onClick={_onClick}>
          <img
            slot="image"
            src="./images/TOWNHOMES.png"
            alt="A kitten walks towards camera on top of pallet."
          />
          <div className="card-title">TOWNHOMES</div>
        </SlCard>
        
        <SlCard className="card-image" id={"JADU"} onClick={_onClick}>
          <img
            slot="image"
            src="./images/JADU.png"
            alt="JADU."
          />
          <div className="card-title">
            JADU
          </div>
        </SlCard>
        <SlCard className="card-image" id={"JADU"} onClick={_onClick}>
          <img
            slot="image"
            src="./images/ADU.png"
            alt="A kitten walks towards camera on top of pallet."
          />
          <div className="card-title">
            ADU
          </div>
        </SlCard>
        <SlCard className="card-image" id={"ADU + JADU"} onClick={_onClick}>
          <img
            slot="image"
            src="./images/ADU+JADU.png"
            alt="A kitten walks towards camera on top of pallet."
          />
          <div className="card-title">ADU + JADU</div>
        </SlCard>
        <SlCard className="card-image" id={"UNIT + ADU + JADU"} onClick={_onClick}>
          <img
            slot="image"
            src="./images/ADU+JADU+UNIT.png"
            alt="A kitten walks towards camera on top of pallet."
          />
          <div className="card-title">UNIT + ADU + JADU</div>
        </SlCard>
       
       {/*  <SlCard className="card-image" id={"CUSTOM"} onClick={_onClick}>
          <img
            slot="image"
            src="./images/CUSTOM.png"
            alt="A kitten walks towards camera on top of pallet."
          />
          <div className="card-title">CUSTOM</div>
        </SlCard> */}
    
            {/* <SlButton variant="primary" pill>
              More Info
            </SlButton> */}
           {/*  link to twitter or something */}
          </div>

     {/*      <footer style={styles.footer}>
            <SlButton slot="footer" variant="primary">
                Current Projects
            </SlButton>
      </footer> */}
      </div>
        </SlCard>   

        <style>{css}</style>
      </>
    )
};

export default Home;